import { render, staticRenderFns } from "./MapList2.vue?vue&type=template&id=2efbe7b4"
import script from "./MapList2.vue?vue&type=script&lang=ts"
export * from "./MapList2.vue?vue&type=script&lang=ts"
import style0 from "./MapList2.vue?vue&type=style&index=0&id=2efbe7b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports